import "normalize.css";
import "./src/styles/index.scss";
import type { GatsbyBrowser } from "gatsby";

const addScript = (src: string, opt: Object = {}) => {
  const script = document.createElement("script");
  script.src = src;
  script.defer = true;
  if (opt) {
    Object.keys(opt).forEach((key) => {
      script[key] = opt[key];
    });
  }
  document.body.appendChild(script);
};

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  const agency = {
    // klaviyoId: "XqccZj",
    metaPixelId: "995654391379499",
  };
  /* if (window.location.host.indexOf("hello") > -1) {
    // agency.klaviyoId = "QVPriR";
    agency.metaPixelId = "995654391379499";
  } */

  // google analytics
  addScript("https://www.googletagmanager.com/gtag/js?id=G-EMQ12NW9NX", {
    onload: function () {
      window["dataLayer"] = window["dataLayer"] || [];
      function gtag(a, b) {
        window["dataLayer"].push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "G-EMQ12NW9NX");
    },
  });

  // klaviyo
  /* var klaviyoForm = document.createElement("div");
  klaviyoForm.className = "klaviyo-form";
  klaviyoForm.id = "klaviyo-form";
  klaviyoForm.innerHTML = '<div class="klaviyo-form-' + agency.klaviyoId + '"></div>';
  document.body.appendChild(klaviyoForm);
  addScript(
    "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=Y87gzZ"
  ); */

  // sentry
  addScript("https://browser.sentry-cdn.com/7.45.0/bundle.tracing.min.js", {
    crossorigin: "anonymous",
    onload: function () {
      var Sentry = window["Sentry"];
      Sentry.onLoad(function () {
        Sentry.init({
          dsn: "https://a7a23c60fe4c41ae9b3bc58946a72e1d@monitor.viture.dev/4",
          integrations: [new Sentry.BrowserTracing()],
          tracesSampleRate: 0.2,
        });
      });
    },
  });

  // Meta Pixel Code
  if (window["fbq"]) return;
  var n = (window["fbq"] = function () {
    n["callMethod"]
      ? n["callMethod"].apply(n, arguments)
      : n["queue"].push(arguments);
  });
  if (!window["_fbq"]) window["_fbq"] = n;
  n["push"] = n;
  n["loaded"] = !0;
  n["version"] = "2.0";
  n["queue"] = [];

  addScript("https://connect.facebook.net/en_US/fbevents.js", {
    crossorigin: "anonymous",
    onload: function () {
      var FBQ = window["fbq"];
      FBQ("init", agency.metaPixelId);
      FBQ("track", "PageView");
    },
  });
};
